'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _AvatarPicker = require('./avatar/AvatarPicker');

var _AvatarPicker2 = _interopRequireDefault(_AvatarPicker);

var _BillingStatusDisplay = require('./billingStatus/BillingStatusDisplay');

var _BillingStatusDisplay2 = _interopRequireDefault(_BillingStatusDisplay);

var _UserPlanBadge = require('../../../../components/userAvatar/UserPlanBadge');

var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);

var _ElectronVisible = require('../../../../components/electron/ElectronVisible');

var _ElectronVisible2 = _interopRequireDefault(_ElectronVisible);

var _ElectronAppStatus = require('./electronApp/ElectronAppStatus');

var _ElectronAppStatus2 = _interopRequireDefault(_ElectronAppStatus);

var _authActions = require('../../../../auth/authActions');

var authActions = _interopRequireWildcard(_authActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        logout: function logout() {
            return dispatch(authActions.logout());
        }
    };
};

var AccountUserPopup = function AccountUserPopup(props) {
    var currentUser = props.currentUser,
        logout = props.logout;


    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({}, props, { className: 'AccountPopup', popupId: 'user' }),
        _react2.default.createElement(
            'div',
            { className: 'header' },
            _react2.default.createElement(
                'div',
                { className: 'user-details' },
                _react2.default.createElement(
                    'div',
                    { className: 'user-name' },
                    _react2.default.createElement(
                        'span',
                        { className: 'name' },
                        currentUser.getIn(['name', 'displayName'])
                    ),
                    _react2.default.createElement(_UserPlanBadge2.default, { user: currentUser })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'email' },
                    currentUser.get('email')
                )
            ),
            _react2.default.createElement(_AvatarPicker2.default, { user: currentUser })
        ),
        _react2.default.createElement(
            'div',
            { className: 'setting-links' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/account/settings' },
                'Account settings'
            ),
            _react2.default.createElement(
                _LinkButton2.default,
                { onClickFn: logout },
                'Log out'
            )
        ),
        _react2.default.createElement(_BillingStatusDisplay2.default, props),
        _react2.default.createElement(
            _ElectronVisible2.default,
            null,
            _react2.default.createElement(_ElectronAppStatus2.default, null)
        )
    );
};

AccountUserPopup.propTypes = {
    currentUser: _propTypes2.default.object.isRequired,
    logout: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AccountUserPopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/AccountUserPopup.js
// module id = 2168
// module chunks = 0